export const RSVP_SUCCESS_BANNER_KEY = 'rsvpsuccess';
export const SUCCESS_HOTEL_RECOMMENDATION_BANNER_KEY = 'rsvpsuccesshotelrecommendation';
